import { ReportState } from "./types";

export const initialState: ReportState = {
  selectedFunction: null,
  items: {},
  currentStep: "function-select"
};
